export function validEmail(str) {
    let emailRegex = /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/
    return emailRegex.test(str.trim())
}

export function validPhone(str) {
    let phoneRegex = /^1[3456789]\d{9}$/
    return phoneRegex.test(str.trim())
}

export function validIdCard(str) {
    let cardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    return cardRegex.test(str.trim())
}

export function validPwd(str) {
    let passRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
    return passRegex.test(str.trim())
}


// WEBPACK FOOTER //
// ./src/utils/validate.js